import Unsubscribe from './components/unsubscribe';
import PersonalInformation from './components/personal-information';
import PersonalInformationConfirmation from './components/personal-information/confirmation';

export default {
  name: 'marketing-permissions',
  routes: {
    '/unsubscribe/complete': {
      fullPageComponent: Unsubscribe,
    },
    '/personal-information/confirmation': {
      fullPageComponent: PersonalInformationConfirmation,
    },
    '/personal-information': {
      fullPageComponent: PersonalInformation,
    },
  },
};
